module.exports = __webpack_public_path__ + "static/img/intro_icon3.9a670bc5.png";